import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import {
  Box,
  Grid2,
  Typography,
  Container,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
} from "@mui/material";
import { ArrowDownward } from '@mui/icons-material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCaretDown, faPuzzlePiece, faShippingFast } from "@fortawesome/free-solid-svg-icons";

import { intro_fourth_texts, intro_fifth_texts } from "../constants/intropageTexts";
import intropageStyles from "../assets/styles/views/intropage.module.css";
import IntroQuickNav from "../layouts/intropage/IntroQuickNav";
import { IntroContent01, IntroContent02, IntroContent03, IntroContent04 } from "../layouts/intropage";

const InBox = styled(Box)(({ theme, customStyle }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mb: 12,
  ...customStyle,
  "& img": {
    width: "85%",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    paddingLeft: "2%",
  },
}));

const sections = [
  { id: "businessGoals", label: "bwob.task1.title" },
  { id: "blockchainLogistics", label: "bwob.task2.title" },
  { id: "coffeeAnalysis", label: "bwob.task3.title" },
  { id: "blockchainCoffee", label: "bwob.task4.title" },
];


const IntroPage = () => {
  const { t } = useTranslation();
  const [showQuickNav, setShowQuickNav] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const isImageView = false;
  const iconType = true ? <FontAwesomeIcon icon={faSquareCaretDown} size="lg" style={{ paddingLeft: '10px', paddingRight: '10px', fontSize: "36px" }} /> : <ArrowDownward />; // : <DocumentScanner />;
  const iconSection = <FontAwesomeIcon icon={faPuzzlePiece} size="lg" style={{ paddingLeft: '10px', paddingRight: '10px' }} />;
  const [expanded, setExpanded] = useState('panel_info_1');
  const [subExpanded, setSubExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    const section = document.getElementById('panel_info_1');
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setExpanded(isExpanded ? panel : null);
  };

  const handleSubChange = (panel) => (event, isExpanded) => {
      const section = document.getElementById('panel_info_1');
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setSubExpanded(isExpanded ? panel : null);
  };

  useEffect(() => {
    document.title = 'BWOB';
    /*
    // const handleScroll = () => {
    //   const position = window.pageYOffset;
    //   setShowQuickNav(position > 300);
    // };
    */

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -50% 0px",
        threshold: 0.1,
      },
    );

    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) observer.observe(element);
    });

    /* window.addEventListener("scroll", handleScroll);*/

    return () => {
      /* window.removeEventListener("scroll", handleScroll); */
      sections.forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) observer.unobserve(element);
      });
    };
  }, []);


  return (
    <Box className="intro-content-layout" sx={{ width: "100%", height: "100%", overflow: "hidden", position: "relative", margin: 0, padding: 0 }}> 
      {showQuickNav ?
        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block' } }}>
          <IntroQuickNav sections={sections} activeSection={activeSection} />
        </Box>
      : null}
      <Box className={intropageStyles.intro_top_bg} sx={{ display: "flex", alignItems: "center" }}>
        <Container sx={{ pt: 2, pb: 6, }} maxWidth="lg">
          <Typography component="h2" variant="h2" gutterBottom>
            <FontAwesomeIcon icon={faShippingFast} style={{ paddingLeft: '0px', paddingRight: '10px' }} />
            {t('bwob.about')}
          </Typography>
          <Typography component="p" variant="subtitle1">
            {t('bwob.subject')}
          </Typography>
        </Container>
      </Box>

      <Box sx={{ width: "100%", height: "100%", overflowY: "auto", overflowX: "hidden", position: "relative", }} className={intropageStyles.intro_contents}>

        <Box id="businessGoals" sx={{  }}>
          <Container sx={{ p: 2, }} maxWidth="lg">
            <Accordion key='panel_info_1' id='panel_info_1' sx={{ width: '100%', mb: 1 }} expanded={expanded === 'panel_info_1'}  onChange={handleChange('panel_info_1')} slotProps={{ transition: { unmountOnExit: true } }}>
              <AccordionSummary expandIcon={iconType} aria-controls="panel_info_1-content" id="panel_info_1-header"
                                sx={{ p: 0, m: 0, backgroundColor: "#FAFAFA", borderRadius: 1, border: "1px solid #F5F5F5", "&.Mui-expanded": { backgroundColor: "#FAFAFA" } }} >
                <Typography component="h3" variant="h3" >
                  {iconSection} {t('bwob.task1.title')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0, m: 1 }}>

                {isImageView ?
                <>
                  <InBox>
                    <img src={`${process.env.PUBLIC_URL}${t('bwob.task1.section1.image.url')}`} alt={t('bwob.task1.section1.image.alt')} />
                  </InBox>
                  <Divider sx={{ my: 8, mx: "auto", backgroundColor: "#003E8D", widht: "90%", }} />
                </>
                : <IntroContent01 expanded={subExpanded} handleChange={handleSubChange} /> }

                {isImageView ? 
                <>
                  <InBox>
                    <img src={`${process.env.PUBLIC_URL}${t('bwob.task1.section2.image.url')}`} alt={t('bwob.task1.section2.image.alt')} />
                  </InBox>
                  <Divider sx={{ my: 8, mx: "auto", backgroundColor: "#003E8D", widht: "90%", }} />
                </>
                : <IntroContent02 expanded={subExpanded} handleChange={handleSubChange} /> }
                
                {isImageView ?
                <InBox>
                  <img src={`${process.env.PUBLIC_URL}${t('bwob.task1.section3.image.url')}`} alt={t('bwob.task1.section3.image.alt')} />
                </InBox>
                : <IntroContent03 expanded={subExpanded} handleChange={handleSubChange} /> }

              </AccordionDetails>
            </Accordion>
            

            
          </Container>
        </Box>
        

        <Box id="blockchainLogistics">
          <Container sx={{ p: 2, }} maxWidth="lg" >
            <Accordion key='panel_info_2' id='panel_info_2' sx={{ width: '100%', mb: 1 }} expanded={expanded === 'panel_info_2'}  onChange={handleChange('panel_info_2')} slotProps={{ transition: { unmountOnExit: true } }}>
              <AccordionSummary expandIcon={iconType} aria-controls="panel_info_2-content" id="panel_info_2-header"
                                sx={{ p: 0, m: 0, backgroundColor: "#FAFAFA", borderRadius: 1, border: "1px solid #F5F5F5", "&.Mui-expanded": { backgroundColor: "#FAFAFA" } }} >
                <Typography component="h3" variant="h3" >
                  {iconSection}  {t('bwob.task2.title')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0, m: 1 }}>
            
                {isImageView ? 
                <InBox customstyle={{ display: "flex", justifyContent: "left", paddingLeft: "10%", marginTop: "4%", }} >
                  <img src={`${process.env.PUBLIC_URL}${t('bwob.task2.section1.image.url')}`} alt={t('bwob.task2.section1.image.alt')} style={{ width: "85%", paddingLeft: "0" }} />
                </InBox>
                : <IntroContent04 /> }

              </AccordionDetails>
            </Accordion>
          </Container>
        </Box>

        <Box id="coffeeAnalysis" sx={{ }}>
          <Container sx={{ p: 2, }} maxWidth="lg">
            <Accordion key='panel_info_3' id='panel_info_3' sx={{ width: '100%', mb: 1 }} expanded={expanded === 'panel_info_3'}  onChange={handleChange('panel_info_3')} slotProps={{ transition: { unmountOnExit: true } }}>
              <AccordionSummary expandIcon={iconType} aria-controls="panel_info_3-content" id="panel_info_3-header"
                                sx={{ p: 0, m: 0, backgroundColor: "#FAFAFA", borderRadius: 1, border: "1px solid #F5F5F5", "&.Mui-expanded": { backgroundColor: "#FAFAFA" } }} >
                <Typography component="h3" variant="h3" >
                  {iconSection}  {t('bwob.task3.title')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0, m: 1 }}>

                <Grid2 container spacing={1}>
                  {intro_fourth_texts.map((item) => (
                    <Grid2 size={{ xs: 12, sm: 12, md: 4 }} key={`${item.id}_${item.title}`}>
                      
                      <Card sx={{ minHeight: "230px", boxShadow: "none" }}>
                        <CardActionArea>
                          <CardMedia sx={{ textAlign: "center", p: 0, alignItems: "center", verticalAlign: "middle", backgroundColor: "#fbfbfb", minHeight: "65px" }}>
                            <img src={item.image} alt={item.imageLabel} />
                          </CardMedia>
                          <CardContent sx={{ minHeight: "140px", padding: "0px 16px" }}>
                            <Typography gutterBottom variant="h5" component="div" sx={{ mt: 2, fontWeight: '500', marginTop: "2px" }}>
                              {t(item.i18nTitle)}
                            </Typography>
                            <Typography variant="body1">{t(item.i18nDescription)}</Typography>    
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      
                    </Grid2>
                  ))}
                </Grid2>

              </AccordionDetails>
            </Accordion>
          </Container>
        </Box>
        {/* contentsC E */}

        <Box id="blockchainCoffee" sx={{}}>
          <Container sx={{ p: 2, }} maxWidth="lg">
            <Accordion key='panel_info_4' id='panel_info_4' sx={{ width: '100%', mb: 1 }} expanded={expanded === 'panel_info_4'}  onChange={handleChange('panel_info_4')} slotProps={{ transition: { unmountOnExit: true } }}>
              <AccordionSummary expandIcon={iconType} aria-controls="panel_info_4-content" id="panel_info_4-header"
                                sx={{ p: 0, m: 0, backgroundColor: "#FAFAFA", borderRadius: 1, border: "1px solid #F5F5F5", "&.Mui-expanded": { backgroundColor: "#FAFAFA" } }} >
                <Typography component="h3" variant="h3" >
                  {iconSection}  {t('bwob.task4.title')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0, m: 1 }}>

                <Grid2 container spacing={1} sx={{ padding: "0px 20px" }}>
                  {intro_fifth_texts.map((item) => (
                    <Grid2 size={{ xs: 12, sm: 12, md: 4 }} key={`${item.id}_${item.title}`}>
                      
                      <Card sx={{ minHeight: "235px", boxShadow: "none" }}>
                        <CardActionArea>
                          <CardMedia sx={{ textAlign: "center", p: 0, alignItems: "center", verticalAlign: "middle", backgroundColor: "#fbfbfb", minHeight: "75px" }}>
                            <img src={item.image} alt={item.imageLabel} />
                          </CardMedia>
                          <CardContent sx={{ minHeight: "160px", padding: "0px 16px" }}>
                            <Typography gutterBottom variant="h5" component="div" sx={{ mt: 2, fontWeight: '500', marginTop: "2px" }}>
                              {t(item.i18nTitle)}
                            </Typography>
                            <Typography variant="body1">{t(item.i18nDescription)}</Typography>    
                          </CardContent>
                        </CardActionArea>
                      </Card>
                      
                    </Grid2>
                  ))}
                </Grid2>

              </AccordionDetails>
            </Accordion>
          </Container>
        </Box>
        {/* contentsD E */}
      </Box>
    </Box>
  );
};
export default IntroPage;
